// Якоря подсветки (общий модуль HQ-2338, вынесен из обучения мира HQ-190): цель на экране — атрибут
// data-tutorial="<ключ>" на элементе; слой подсветки находит его по атрибуту и вырезает затемнение по его рамке.
// Ключи мира — screens/world/tutorial/anchors.ts; ключи тура по приложению — tab.<вкладка>, header.<вкладка>.<пункт>,
// list.matches.first (src/tour/anchors.ts).

export const ANCHOR_ATTR = 'data-tutorial';
/** Видимая часть большой цели: вырез рисуем по ней (калитка — во всю ширину арены, под ней боковые кнопки), а нажатие
 *  засчитывается по всей цели. Нет такой части на экране (калитка меняется) — вырез по самой цели. */
export const FOCUS_ATTR = 'data-tutorial-focus';

/** Атрибут якоря для JSX: `<button {...anchorAttr('team.hire')}>`; нет якоря — ничего. */
export const anchorAttr = (anchor: string | null | undefined): Record<string, string> => (anchor ? { [ANCHOR_ATTR]: anchor } : {});
/** Атрибут видимой части цели (см. FOCUS_ATTR). */
export const anchorFocusAttr: Record<string, string> = { [FOCUS_ATTR]: '' };

/** HQ-2343: метка-якорь внутри чужой кнопки (нижняя панель мира — общий компонент приложения, своих атрибутов не берёт):
 *  цель шага — ближайшая кнопка над меткой, сама метка скрыта. `<span {...anchorInButtonAttr('tab.club')} />` */
export const IN_BUTTON_ATTR = 'data-tutorial-in-button';
export const anchorInButtonAttr = (anchor: string): Record<string, string> => ({ [ANCHOR_ATTR]: anchor, [IN_BUTTON_ATTR]: '' });
/** Элемент цели по найденному якорю: метка внутри кнопки — сама кнопка, иначе — он же. */
export function anchorTarget(el: HTMLElement): HTMLElement {
  return el.hasAttribute(IN_BUTTON_ATTR) ? el.parentElement?.closest<HTMLElement>('button') ?? el : el;
}
